import { frontendURL } from '../../../helper/URLHelper';
import KanbanView from './KanbanView.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban/:kanbanId'),
    name: 'kanban_dashboard_index',
    component: KanbanView,
    meta: commonMeta,
    props: route => ({
      kanbanId: Number(route.params.kanbanId),
      // Set when navigating here from the conversation sidebar's "Abrir Kanban" button (see
      // conversation/kanban/KanbanBox.vue) — highlights and scrolls to that conversation's
      // card once the board loads.
      conversationId: route.query.conversation_id
        ? Number(route.query.conversation_id)
        : null,
    }),
  },
];
